import { useState } from 'react'
import { Calendar, ChevronDown } from 'lucide-react'
import { Button } from '../ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { useAnalyticsStore } from '../../stores/analyticsStore'
import { format, subDays } from 'date-fns'

const PRESETS = [
  { label: 'Last 7 days', days: 7 },
  { label: 'Last 30 days', days: 30 },
  { label: 'Last 90 days', days: 90 },
  { label: 'Last 365 days', days: 365 },
]

export function DateRangePicker() {
  const { setDateRange } = useAnalyticsStore()
  const [selectedPreset, setSelectedPreset] = useState(30) // Default to 30 days

  const handlePresetClick = (days: number) => {
    const to = new Date()
    const from = subDays(to, days)
    setDateRange({
      from: format(from, 'yyyy-MM-dd'),
      to: format(to, 'yyyy-MM-dd'),
    })
    setSelectedPreset(days)
  }

  const getButtonText = () => {
    const preset = PRESETS.find((p) => p.days === selectedPreset)
    return preset?.label || 'Select range'
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="justify-start">
          <Calendar className="mr-2 h-4 w-4" />
          {getButtonText()}
          <ChevronDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        <DropdownMenuLabel>Date Range</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {PRESETS.map((preset) => (
          <button
            key={preset.days}
            onClick={() => handlePresetClick(preset.days)}
            className={`flex w-full items-center rounded-sm px-2 py-2 text-sm hover:bg-accent ${
              selectedPreset === preset.days ? 'bg-accent' : ''
            }`}
          >
            {preset.label}
          </button>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
